var map = {
	"./Syllabus.png": "16cb",
	"./ask.png": "c2f9",
	"./attendance.png": "023c",
	"./books.png": "f398",
	"./bus-school.png": "8485",
	"./downloads.png": "d23c",
	"./events.png": "9319",
	"./exams.png": "22e7",
	"./feedback.png": "c630",
	"./fees.png": "30f3",
	"./gallery.png": "d180",
	"./holidays.png": "3bc4",
	"./homework.png": "5eec",
	"./live-lectures.png": "3e11",
	"./magazine.png": "921f",
	"./messages.png": "1fed",
	"./notice.png": "3ad8",
	"./quiz.png": "f7c9",
	"./tests.png": "4f61",
	"./timetable.png": "7d6d",
	"./video-lectures.png": "a4c7",
	"./website.png": "0183"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2de2";